import { DEFAULT_BORDER } from 'constants/global';

import Star from 'assets/icons/star.svg';
import Notes from 'assets/icons/notes.svg';
import Finens from 'assets/icons/finens.svg';
import HandUp from 'assets/icons/handUp.svg';
import Measuring from 'assets/icons/Measuring.svg';
import Analytics from 'assets/icons/analytics.svg';

const sameStyles = {
  boxSize: 'unset',
  w: { mobile: '308px', tablet: '270px', laptop: '375px' },
  h: { mobile: '240px', tablet: '240px', laptop: '300px' },
  p: { laptop: '0 32px 32px 32px', mobile: '0 16px 16px 16px' },
  borderRadius: { laptop: '40px', mobile: '20px' },
  titleProps: { textStyle: 'h1', fontWeight: '500' },
  iconProps: {
    bgColor: 'unset',
    boxSize: '72px',
    top: { mobile: '0', laptop: '16px' },
    left: { mobile: '0', laptop: '16px' },
  },
};

export const consultingSecondExpertiseCardsSliderData = {
  title: 'Результаты консультирования',
  cardsData: [
    { src: Star, title: 'Повышение отдачи от инвестиций' },
    { src: Notes, title: 'Оптимизация затрат на работу ИТ\u2011системы' },
    { src: Measuring, title: 'Сокращение операционных издержек' },
    { src: Finens, title: 'Увеличение стоимости бизнеса' },
    { src: HandUp, title: 'Повышение уровня клиентской лояльности' },
    { src: Analytics, title: 'Рост эффективности бизнес-процессов' },
  ],
  cardsStyles: [
    { bgColor: 'bg.neonLight', ...sameStyles },
    { bgColor: 'bg.white', border: DEFAULT_BORDER, borderColor: 'line.gray', ...sameStyles },
    { bgColor: 'bg.gray', ...sameStyles },
    { bgColor: 'bg.grayLight', ...sameStyles },
    { bgColor: 'bg.accent', ...sameStyles },
    { bgColor: 'bg.neonLight', ...sameStyles },
  ],
};
